import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="container mx-auto px-4">
        {/* Main footer content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-12 mb-12">
          {/* Logo & Company Info */}
          <div>
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-12 h-12 flex items-center justify-center overflow-hidden rounded-xl">
                <img src="/logo.png" alt="Kiểm Tra Năng Lực Logo" className="w-full h-full object-contain" />
              </div>
              <div className="flex flex-col">
                <span className="text-2xl font-bold">KiểmTraNăngLực</span>
                <span className="text-[10px] font-medium text-blue-400 uppercase tracking-widest mt-1">TỔ HỢP TEST TÂM LÝ</span>
              </div>
            </div>
            <p className="text-gray-300 text-sm leading-relaxed mb-6 max-w-xs">
              Nền tảng test tính cách và trí tuệ hàng đầu VN
            </p>
            <div className="space-y-3 text-gray-300 text-sm">
              <div className="flex items-start">
                <svg className="w-4 h-4 mr-3 mt-0.5 text-blue-400 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                </svg>
                <span>30 Đường Thị Mười, Phường TTH, Quận 12, TPHCM</span>
              </div>
              <div className="flex items-start">
                <svg className="w-4 h-4 mr-3 mt-0.5 text-blue-400 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                  <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                </svg>
                <span>nguyenhuynhduc120597@gmail.com</span>
              </div>
              <div className="flex items-start">
                <svg className="w-4 h-4 mr-3 mt-0.5 text-blue-400 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                </svg>
                <span>0927663809</span>
              </div>
            </div>
          </div>
          
          {/* Tests Column */}
          <div>
            <h3 className="text-lg font-bold mb-6 text-white uppercase tracking-wide">CÁC BÀI TEST</h3>
            <ul className="space-y-3">
              <li>
                <a href="/test-iq" className="group flex items-center text-gray-300 hover:text-white transition-colors duration-200">
                  <div className="w-3 h-3 bg-blue-500 rounded-full mr-3 group-hover:scale-110 transition-transform flex-shrink-0"></div>
                  <span className="text-sm">Test IQ - Đánh giá chỉ số thông minh</span>
                </a>
              </li>
              <li>
                <a href="/test-mbti" className="group flex items-center text-gray-300 hover:text-white transition-colors duration-200">
                  <div className="w-3 h-3 bg-purple-500 rounded-full mr-3 group-hover:scale-110 transition-transform flex-shrink-0"></div>
                  <span className="text-sm">Test MBTI - Phân tích tính cách</span>
                </a>
              </li>
              <li>
                <a href="/test-eq" className="group flex items-center text-gray-300 hover:text-white transition-colors duration-200">
                  <div className="w-3 h-3 bg-green-500 rounded-full mr-3 group-hover:scale-110 transition-transform flex-shrink-0"></div>
                  <span className="text-sm">Test EQ - Trí tuệ cảm xúc</span>
                </a>
              </li>
              <li>
                <a href="/test-disc" className="group flex items-center text-gray-300 hover:text-white transition-colors duration-200">
                  <div className="w-3 h-3 bg-yellow-500 rounded-full mr-3 group-hover:scale-110 transition-transform flex-shrink-0"></div>
                  <span className="text-sm">Test DISC - Phong cách hành vi</span>
                </a>
              </li>
              <li>
                <a href="/holland-codes" className="group flex items-center text-gray-300 hover:text-white transition-colors duration-200">
                  <div className="w-3 h-3 bg-red-500 rounded-full mr-3 group-hover:scale-110 transition-transform flex-shrink-0"></div>
                  <span className="text-sm">Holland Codes - Định hướng nghề nghiệp</span>
                </a>
              </li>
            </ul>
          </div>
          
          {/* Contact/CTA Column */}
          <div>
            <h3 className="text-lg font-bold mb-6 text-white uppercase tracking-wide">LIÊN HỆ HỖ TRỢ</h3>
            <div className="space-y-4">
              <div className="bg-gradient-to-r from-blue-600/20 to-purple-600/20 rounded-lg p-4 border border-gray-700">
                <p className="text-blue-400 font-semibold text-sm mb-2">Hotline 24/7</p>
                <p className="text-white font-bold text-lg">0927663809</p>
              </div>
              <div className="bg-gradient-to-r from-green-600/20 to-blue-600/20 rounded-lg p-4 border border-gray-700">
                <p className="text-green-400 font-semibold text-sm mb-2">Email hỗ trợ</p>
                <p className="text-white font-bold text-sm">nguyenhuynhduc120597@gmail.com</p>
              </div>
            </div>
          </div>
        </div>
        
        {/* Bottom section */}
        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col lg:flex-row justify-between items-center space-y-4 lg:space-y-0">
            <div className="text-gray-400 text-sm text-center lg:text-left">
              <p>&copy; 2025 KiểmTraNăngLực. All rights reserved.</p>
              <div className="flex flex-wrap justify-center lg:justify-start gap-4 mt-2">
                <a href="/privacy-policy" className="hover:text-white transition-colors">
                  Chính sách bảo mật
                </a>
                <span className="text-gray-600">•</span>
                <a href="/terms-of-service" className="hover:text-white transition-colors">
                  Điều khoản sử dụng
                </a>
              </div>
            </div>
            <div className="flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-6 text-sm">
              <div className="flex items-center space-x-2">
                <span className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></span>
                <span className="text-gray-300">Hoạt động 24/7</span>
              </div>
              <div className="flex items-center space-x-2">
                <span className="w-2 h-2 bg-blue-400 rounded-full"></span>
                <span className="text-gray-300">Bảo mật SSL</span>
              </div>
              <div className="flex items-center space-x-2">
                <span className="w-2 h-2 bg-purple-400 rounded-full"></span>
                <span className="text-gray-300">Miễn phí 100%</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
